import React from 'react'
import {formatDate} from '../components/datepicker'
import {connect} from 'react-redux'

@connect(
  (state, ownProps) => ({
    language: ownProps.language || state.reportSettings.layout.language,
    dateFormat: ownProps.dateFormat || state.reportSettings.layout.dateFormat
  })
)
export class Timer extends React.Component {
  interval
  state = {}

  tick = () => {
    this.setState({secondsElapsed: this.state.secondsElapsed + 1})
  }

  componentDidMount() {
    this.interval = setInterval(this.tick, 60 * 1000)
    this.loadLanguage(this.props.language)
  }

  componentWillReceiveProps(newProps) {
    if (newProps.language !== this.props.language) {
      this.loadLanguage(newProps.language)
    }
  }

  loadLanguage(languageKey) {
    import(`./date.i18n/${languageKey}`).then((lang) => this.setState({lang: lang[languageKey]}))
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    const {time, alwaysDate, noHours, dateFormat, shortMonth, noPrefix, onInvalid} = this.props
    const lang = this.state.lang
    if (!lang) return null

    if (!alwaysDate && time + 60 * 60 * 1000 > Date.now()) {
      return <span>{Math.round((Date.now() - time) / (60 * 1000)) + ' minutes ago'}</span>
    }
    const date = new Date(time)
    if (isNaN(date.getTime())) {
      return <span>{onInvalid ? onInvalid : 'Invalid date'}</span>
    }
    return <span>{!noPrefix && 'on '}{formatDate(date, lang, dateFormat.replace('LL', shortMonth ? 'L' : 'LL') + (noHours ? '' : ' - hh:mm'))}</span>
  }
}


// WEBPACK FOOTER //
// ./~/report-components/src/components/timer.js